module.exports = "./img/a535373758d94d9ecfb73a3444f24560.jpg";